import React from 'react';

import SectionMessage from '@atlaskit/section-message';
import { useAssociatedServices } from 'src/services/associatedServices';
import { useJiraContext } from 'src/services/jira';
import { useLinkedIncident } from 'src/services/linkedIncident';
import { useSession } from 'src/services/session';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import JiraSideAdminLink from 'src/views/components/links/JiraSideAdminLink';
import LoginLink from 'src/views/components/links/LoginLink';

import CreateIncidentButton from './components/CreateIncidentButton';
import Footer from './components/Footer';
import IncidentView from './components/IncidentView';
import LinkedIncidentErrorMessage from './components/LinkedIncidentErrorMessage';
import LinkIncidentButton from './components/LinkIncidentButton';

const NoLinkedIncident = () => (
  <div data-cy="no-linked-incident">
    There is no linked incident.
    <br/>
    <br/>
    <CreateIncidentButton/>
    <br/>
    <LinkIncidentButton/>
    <br/>
    <br/>
  </div>
);

const PleaseLoginOrConnectMessage = () => (
  <SectionMessage appearance={'info'}>
    Your Jira is not linked to PagerDuty. Please <JiraSideAdminLink>configure connection</JiraSideAdminLink> or <LoginLink>Login with
    PagerDuty</LoginLink>.
  </SectionMessage>
);

const ChooseView = () => {
  const jira = useJiraContext();
  const linkedIncident = useLinkedIncident();
  const associatedServices = useAssociatedServices();
  const session = useSession();

  const loading = jira.loading || linkedIncident.loading || associatedServices.loading || session.loading;
  if (jira.error) return <ErrorMessage error={jira.error}/>;
  if (linkedIncident.error) return <LinkedIncidentErrorMessage linkedIncident={linkedIncident}/>;

  if (loading) return <CenteredSpinner size="large"/>;
  if (linkedIncident.incident) return <IncidentView incident={linkedIncident.incident} incidentAccountDomain={linkedIncident.incidentAccountDomain}/>;
  if (associatedServices.hasAtLeastOneService || session.loggedIn) return <NoLinkedIncident/>;
  if (jira.settings.v3AuthToken && jira.settings.v3AuthToken.value) return <NoLinkedIncident/>;
  return <PleaseLoginOrConnectMessage/>;
};

const IssueSidebar = () => {
  const isCypress = Boolean(window.Cypress);

  return (
    <div style={{ minHeight: 400, maxWidth: isCypress ? 350 : undefined, textAlign: 'center', width: '97%', margin: isCypress ? 'auto' : undefined }}>
      <ChooseView/>
      <Footer/>
    </div>
  );
};

export default IssueSidebar;
